import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';


const ExternalGame = loadable(() => pMinDelay(import('./ExternalGame'), 300), {
  fallback: <Loading />
});

const AsyncExternalGame = props => {
  const pageConfig = {
    headerType: props?.userAgent?.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props?.userAgent?.device?.type === 'desktop' ? 'full' : 'none',
    hideStickyNavigation: true,
    helmet: {
      bodyAttributes: {
        class: `${props?.userAgent?.device?.type} hide-betslip hide-sticky-navigation bg-solid-grey`
      }
    }
  };


  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <ExternalGame { ...props } { ...pageConfig }/>
    </ApplicationLayout>
  );
};

AsyncExternalGame.propTypes = {
  userAgent: PropTypes.object,
  type: PropTypes.object,
};

export default AsyncExternalGame;
